// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28IJY","content":"styles_content__wlIt_","selectAll":"styles_selectAll__3o8mr"};